module.exports = __webpack_public_path__ + "media/images/flags/pa-a1eaeda15cbe31e54ca615acca41a6e5.svg";